import { AfterContentChecked, Component, EventEmitter, Input, Output } from '@angular/core';
import { fade } from '@common/animations/fade';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { User } from '@common/models/user';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-sidebar-profile',
    templateUrl: './sidebar-profile.component.html',
    animations: [fade]
})
export class SidebarProfileComponent implements AfterContentChecked {
    @Output() togglePinSidebar = new EventEmitter();
    @Output() toggleTheme = new EventEmitter();
    @Output() uploadImage = new EventEmitter();
    @Input() isSidebarExpanded: boolean;
    @Input() isSidebarPinned: boolean;
    @Input() currentUser: User;
    @Input() darkTheme: boolean;
    languages = this.commonService.i18nService.languages;
    currentLanguage = this.commonService.i18nService.currentLanguage;
    languageFlag = false;

    constructor(private commonService: CommonService) {}

    ngAfterContentChecked(): void {
        this.getLanguageFlagValue();
    }

    logout() {
        this.commonService.dialogService
            .confirm({
                options: {
                    title: this.commonService.translateService.instant('Sign Out') as string,
                    titleIcons: ['faSolidArrowRightFromBracket'],
                    message: this.commonService.translateService.instant('Are you sure you want to sign out?') as string
                }
            })
            .then((result) => {
                if (result === true) {
                    this.commonService.router.navigate(['/logout']);
                }
            });
    }

    navigateToUserSettings = () => this.commonService.router.navigate(['/user-settings']);

    toggleCompactMode() {
        this.commonService.compactModeService.toggle();
    }

    isCompactMode() {
        return this.commonService.compactModeService.get();
    }

    private getLanguageFlagValue() {
        const settings = this.commonService.queryService.queryClient.getQueryData<Setting[]>(['settings']);
        if (settings) {
            const languageFlagSetting = settings?.find((s: Setting) => s.key === SettingKeyCodes.LanguageFlag);
            if (languageFlagSetting) this.languageFlag = languageFlagSetting.value === 'true';
        }
    }
}
